import { Controller } from "@hotwired/stimulus";

// The Word template is an ordinary file download, so the page stays put. A moment after the click,
// the offer to take the work into the product appears under the button.
export default class extends Controller {
  static targets = ["panel"];

  downloaded() {
    setTimeout(() => {
      this.panelTarget.hidden = false;
      this.panelTarget.scrollIntoView({ behavior: "smooth", block: "nearest" });
    }, 600);
  }
}
